import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FatNbs } from '../interfaces/fat-nbs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class FatNbsService {

  readonly path = '/fatnbs';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  getFatNbsById(id: number): Observable<FatNbs> {
    return this.http.get<FatNbs>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getFatNbsByCodigo(codigo: string): Observable<FatNbs> {
    return this.http.get<FatNbs>(`${this.jwtAuthService.apiUrl + this.path}/codigo/${codigo}`);
  }

  getFatNbsPage(page?: number, size?: number): Observable<PageResult<FatNbs>> {
    return this.http.get<PageResult<FatNbs>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}`);
  }

  getFatNbsPageSearch(page?: number, size?: number, search?: string): Observable<PageResult<FatNbs>> {
    return this.http.get<PageResult<FatNbs>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&search=${search}`);
  }

}
